import { render, staticRenderFns } from "./co-list-events.vue?vue&type=template&id=998c38de&"
import script from "./co-list-events.vue?vue&type=script&lang=ts&"
export * from "./co-list-events.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports